import { WindowCommon } from '@nx-frontend/features/web-editor/types';

/**
 * Angular's web components use window.__NIMBUS_COMMON for listening event from socketIO or components events
 * @param callback
 * @returns
 */
export function onWindowCommonReady(callback: (windowCommon: WindowCommon) => void) {
  if (window.__NIMBUS_COMMON) {
    callback(window.__NIMBUS_COMMON);
    return;
  }

  const IID: NodeJS.Timer | number = setInterval(() => {
    if (window.__NIMBUS_COMMON) {
      callback(window.__NIMBUS_COMMON);
      clearInterval(IID);
    }
  }, 500);
}
